import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function ForbiddenPage() {
  const { logout } = useAuth();

  return (
    <div className="flex h-full items-center justify-center bg-background">
      <div className="max-w-md px-6 text-center">
        <h1 className="text-xl font-semibold text-foreground">Access denied</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Studio Admin requires the <code className="font-mono">manage:studio</code> permission, or
          Creator Access (<code className="font-mono">build:studio-integrations</code>)
          for the Integration Builder. Sign in with an account that has one of them.
        </p>
        <Button
          type="button"
          className="mt-6"
          variant="outline"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
